import { images } from ".";

const offers = [
    { 
        id: 1, 
        image: images.offer1, 
        description: "Lease for $899/month", 
        title: "2025 Luxury Sedan", 
        link: "Car-Grid" 
    },
    { 
        id: 2, 
        image: images.offer2, 
        description: "0% APR for 36 Months", 
        title: "2025 Classic Collection", 
        link: "Car-Grid" 
    },
    { 
        id: 3, 
        image: images.offer3, 
        description: "Get $2,000 Off", 
        title: "2025 Black Sedan Special", 
        link: "Car-Grid" 
    },
    { 
        id: 4, 
        image: images.offer4, 
        description: "Extra $1,000 Credit", 
        title: "Trade-In for New Cars", 
        link: "Car-Grid" 
    },
    { 
        id: 5, 
        image: images.offer5, 
        description: "Up to $5,000 Off", 
        title: "Speed & Style Sale", 
        link: "Car-Grid" 
    },
];

export default offers;